import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader/loader.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CurrencyPlnPipe } from './currencyPLN.pipe';
import { environment } from 'environments/environment';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
      }
    }),
  ],
  declarations: [
    LoaderComponent,
    CurrencyPlnPipe
  ],
  exports : [
    LoaderComponent,
    TranslateModule,
    CurrencyPlnPipe
  ]
})
export class UiModule { }



// WEBPACK FOOTER //
// ./src/app/ui/ui.module.ts